module.exports = __webpack_public_path__ + "img/calendar_black_icon.245d3823.svg";